/**
 * TextField Component
 *
 * Abstraction layer over MUI TextField.
 * Includes centralized focus styling and validation patterns.
 */

import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import React from 'react';

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return <MuiTextField ref={ref} {...props} />;
});

TextField.displayName = 'TextField';

export default TextField;
